import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Highlight } from "~/components";
import { usePartner } from "~/OnboardingApp/hooks";
import { Trans } from "~/utils/i18next";

const components = {
  Highlight: (
    <Highlight
      fontWeight="bold"
      highlightColor="var(--chakra-colors-newBlue-100)"
    />
  ),
};

export const PartnerCallout: FC = () => {
  const { t } = useTranslation();
  const { partnerMeta } = usePartner();
  const partnerName = partnerMeta?.name || "your clinic";

  return (
    <Flex align="center" direction="column" gap={4} w="full">
      <Box
        bg="th.white"
        borderRadius="lg"
        px={6}
        py={5}
        textAlign="center"
        w="80%"
      >
        <Text
          fontSize={{ base: "18px", md: "1.5rem" }}
          fontWeight="bold"
          lineHeight={{ base: "1.9", md: "1.8" }}
        >
          <Trans
            components={components}
            i18nKey="onboarding.welcomeNamePage.partner.boxContent"
            values={{ partnerName }}
          />
        </Text>
      </Box>
      <Text fontWeight="bold" textAlign="center" variant="th-body2">
        {t("onboarding.welcomeNamePage.partner.disclaimer")}
      </Text>
      <Flex
        align="center"
        bg="th.signatureGreen"
        borderRadius="full"
        color="th.white"
        gap={2}
        px={5}
        py={3}
      >
        <Box
          alignItems="center"
          border="1.5px solid"
          borderColor="th.white"
          borderRadius="full"
          display="flex"
          h={4}
          justifyContent="center"
          w={4}
        >
          <Box bg="th.white" borderRadius="full" h={1} w={1} />
        </Box>
        <Text color="th.white" textTransform="uppercase" variant="th-t2">
          {t("onboarding.welcomeNamePage.partner.estimatedTime")}
        </Text>
      </Flex>
    </Flex>
  );
};
